// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled product page wrapper
export const ProductWrapper = styled.main`
    /* Appearance */
    background-color: ${colors.primaryBeige};

    /* Element disposition */
    flex-grow: 1;

    /* Spacing */
    padding: 50px;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    /* Mobile setup */
    @media (max-width: 600px) {
        gap: 10px;

        padding: 10px;
    }
`;
